import { Component, Injector, OnInit, inject } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { Company } from '../../models/company';
import { CompanyService } from '../../services/company/company.service';
import { UserService } from '../../services/user/user.service';
import { PaymentService } from '../../services/payment/payment.service';

@Component({
    selector: 'app-company-payment-issue',
    templateUrl: './company-payment-issue.component.html',
    styleUrls: ['./company-payment-issue.component.scss']
})
export class CompanyPaymentIssueComponent extends BaseComponent implements OnInit {
    companyId: string = '';
    companyStatus: string | null = null;
    company?: Company;
    loading = false;
    retryLoading = false;
    mode: 'none' | 'changeMethod' = 'none';

    private companyService = inject(CompanyService);
    private userService = inject(UserService);
    private paymentService = inject(PaymentService);

    constructor(public serviceInjector: Injector) {
        super(serviceInjector);
    }

    async ngOnInit() {
        this.companyId = (this.utils.getJwtCompanyId() || localStorage.getItem('wisper_companyId')) ?? '';
        this.companyStatus = this.utils.getJwtCompanyStatus();

        if (this.companyStatus !== 'paymentFailed' && this.companyStatus !== 'pendingPayment') {
            this.navigate.navigate(this.utils.getCompanyManagerHomeRoute());
            return;
        }

        await this.loadCompany();
    }

    private async loadCompany() {
        if (!this.companyId) return;
        this.loading = true;
        try {
            const companies = await this.companyService.getCompanies({ id: this.companyId });
            if (Array.isArray(companies) && companies.length > 0) {
                this.company = new Company(companies[0]);
            }
        } finally {
            this.loading = false;
        }
    }

    get currentPlanName(): string {
        return this.company?.service?.name || 'Piano attuale';
    }

    get currentBillingPeriodLabel(): string {
        return this.billingPeriod === 'yearly' ? 'Annuale' : 'Mensile';
    }

    get billingPeriod(): 'monthly' | 'yearly' {
        return this.company?.billedPeriod === 'yearly' ? 'yearly' : 'monthly';
    }

    get canRetryPayment(): boolean {
        return !!this.company?.service?.id;
    }

    async retryPayment() {
        if (!this.canRetryPayment || this.retryLoading) return;
        this.retryLoading = true;
        const result = await this.paymentService.retryCompanyPayment(this.companyId);
        this.retryLoading = false;

        if (!result) {
            this.showErrorMessage('Errore durante il tentativo di pagamento. Riprova.');
            return;
        }

        if (result.paid) {
            this.showSuccessMessage('Pagamento completato con successo.');
            await this.userService.refreshJwtFromRefreshToken(false);
            this.navigate.navigate(this.utils.getCompanyManagerHomeRoute());
            return;
        }

        this.showInfoMessage(`Pagamento non completato. Stato: ${result.status || 'sconosciuto'}${result.invoiceId ? ` (fattura: ${result.invoiceId})` : ''}`);
    }

    openChangePaymentMethod() {
        this.mode = 'changeMethod';
    }

    backToActions() {
        this.mode = 'none';
    }

    async onPaymentCompleted() {
        await this.userService.refreshJwtFromRefreshToken(false);
        this.navigate.navigate(this.utils.getCompanyManagerHomeRoute());
    }
}
